import * as React from 'react';
import { EmptyIcon } from '../../../assets/icons/NotificationsEmptyIcon';
import { useLocation } from 'react-router-dom';


const Empty = () => {
  let location = useLocation();
  let type = location.pathname.includes('invoice')
   ? 'invoice'
   : location.pathname.includes('expense') 
   ? 'expense' 
   : location.pathname.includes('customer') 
     ? 'customer'
     : undefined;
     let text = type 
     ? type === 'customer'
       ? `You do not have any ${type}s. Add a ${type} to start.` 
       : `You do not have any ${type}s. Create an ${type} to view data.`
     : '';
  return (
    <div>
      <div className="w-full bg-white p-24 pt-10 flex flex-col items-center justify-center gap-12">
        <EmptyIcon />
        <div className="flex items-center justify-center ">
          <p className="font-medium text-black"> {text} </p>
        </div>
      </div>
    </div>
  );
};

export default Empty;
